<div style="display: flex; flex-direction: column; width: 100%; height: 100%">

  <div class="header">
    <div>
      @if (fromAdmin && backHref) {
        <a class="link" [href]="backHref" data-testid="view-assessment-back">
          <mat-icon style="font-size: 22px;" aria-hidden="true">arrow_back</mat-icon>
          Back</a>
      } @else {
        <a class="link" [routerLink]="['/']" data-testid="view-assessment-back">
          <mat-icon style="font-size: 22px;" aria-hidden="true">arrow_back</mat-icon>
          Back</a>
      }
    </div>
    <div style="width: 100%"></div>
    <div>
      <lib-button (click)="downloadReport()">Download</lib-button>
    </div>
  </div>

  @if (this.report?.b2c === 1) {
    <app-video-guide/>
  }

  <div *ngIf="loading" style="display: flex; flex-direction: column; width: 100%; height: 100%; justify-content: center; align-items: center;">
    <lib-content-loader ></lib-content-loader>

  </div>

  <app-report style="display: flex; justify-content: center;" *ngIf="!loading" [report]="report" [download]="download"></app-report>

</div>